import { Component, Output, EventEmitter, OnInit } from "@angular/core";
import { HomeService } from "../../home.service";
import { Type, Brand, ApiConnexion, isResultConnexion, LongBrand } from "@models/interfaces/index";
import { BrandService } from "@shared/services/brand.service";
import { TypeService } from "@shared/services/type.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Router } from "@angular/router";

@Component({
    selector: "mv-lists-home-forms",
    styleUrls: ["./forms.component.scss"],
    templateUrl: "./forms.component.html",
})
export class HomeFormsComponent implements OnInit {
    public brand: Brand;
    public type: Type;
    public longBrand: LongBrand;

    @Output() showPopup: EventEmitter<boolean> = new EventEmitter();
    @Output() showLoader: EventEmitter<boolean> = new EventEmitter();

    public idMail: string = "";
    public idPassword: string = "";
    public errorConnexion: boolean = false;
    public messageError: string = "";
    private readonly destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private homeService: HomeService,
        private brandService: BrandService,
        private typeService: TypeService,
        private router: Router,
    ) {}

    ngOnInit() {
        this.brandService.brand$.pipe(takeUntil(this.destroy$)).subscribe((brandVal) => {
            this.brand = brandVal;
            this.longBrand = brandVal === "mv" ? "MarcoVasco" : "PrestigeVoyages";
        });

        this.typeService.type$.pipe(takeUntil(this.destroy$)).subscribe((typeVal) => {
            this.type = typeVal;
        });
    }

    public login(): void {
        this.homeService.login(this.idMail, this.idPassword).subscribe(
            (dataConnexion: ApiConnexion) => {
                this.errorConnexion = false;
                if (isResultConnexion(dataConnexion)) {
                    if (this.longBrand === dataConnexion.data.brand) {
                        sessionStorage.setItem("ng2-webstorage|current-list", dataConnexion.data.listId);
                        this.router.navigate(["/ma-liste"]);
                    } else {
                        this.errorConnexion = true;
                        this.messageError = "Identifiant ou mot de passe incorrect.";
                    }
                }
            },
            (error) => {
                console.log(error);
                this.errorConnexion = true;
                this.messageError = error;
            },
        );
    }

    public showPopupSearch(): void {
        this.showPopup.emit();
    }
}
